<template>
  <ReviewItemDetailsLayout
    :review-item="incident"
    :expansion-panel="expansionPanel"
    :item-url="incident.metadata.url"
  >
    <template #subtitle>
      <p class="text-sm text-neutral-text-subtitle">
        {{ incident.metadata.eventType }}
      </p>
    </template>

    <template #expanded-content>
      <div class="flex justify-between gap-2">
        <div class="w-full sticky bottom-0 right-0">
          <div
            class="p-4 text-sm text-neutral-text-body block bg-light-neutral-200 w-full min-w-0 rounded-lg"
          >
            <p v-if="incident.metadata.summary" v-html="formattedSummary"></p>
            <p v-else class="text-gray-400 block w-full">Abstract not available</p>
          </div>
        </div>
      </div>
    </template>
  </ReviewItemDetailsLayout>
</template>

<script setup lang="ts">
import { computed } from "vue";
import ReviewItemDetailsLayout from "./ReviewItemDetailsLayout.vue";
import { Incident } from "@core/domain/models/incident.model";
import { applyHighlights } from "@app/utils/words-highlighter";
import useExpansionPanel from "@app/composables/use-expansion-panel";
import { injectStrict } from "@app/utils/injectStrict";
import { ReviewKey } from "@app/views/Review/use-review";

const props = defineProps<{
  incident: Incident;
  expansionPanel: ReturnType<typeof useExpansionPanel>;
}>();

const review = injectStrict(ReviewKey);

const formattedSummary = computed(() => {
  let summary = props.incident.metadata.summary;
  if (!summary) return "";

  if (review.filtering.terms.value.length > 0) {
    summary = applyHighlights(summary, review.filtering.terms.value);
  }
  const titleRegex = /(Additional Manufacturer Narrative:|Description of Event or Problem:)/g;
  summary = summary.replaceAll("\n", "<br>");
  summary = summary.replace(titleRegex, "<strong>$1</strong> ");
  return summary;
});
</script>
